import * as T from '@/core/configs/types'
import { Note, NoteWrapUp } from './note'
export const Goods = {
  id: {
    type: T.String,
    label: 'Goods ID',
    key: 'id',
    col: 'goods_id'
  },
  containerId: {
    type: T.String,
    label: 'Container ID',
    key: 'containerId',
    col: 'container_id'
  },
  sku: {
    type: T.String,
    label: 'SKU',
    key: 'sku',
    col: 'sku'
  },
  addressCode: {
    type: T.String,
    label: 'Dest Fact.',
    key: 'addressCode',
    col: 'address_code'
  },
  addressId: {
    type: T.String,
    label: 'Address Id.',
    key: 'addressId',
    col: 'address_id'
  },
  shipmentNo: {
    type: T.String,
    label: 'Shipment No.',
    key: 'shipmentNo',
    col: 'shipment_no'
  },
  referenceNo: {
    type: T.String,
    label: 'Reference No.',
    key: 'referenceNo',
    col: 'reference_no'
  },
  quantity: {
    type: T.Number,
    label: 'Quantity',
    key: 'quantity',
    col: 'quantity'
  },
  kilograms: {
    type: T.Number,
    label: 'Kilograms',
    key: 'kilograms',
    col: 'kilograms'
  },
  cmb: {
    type: T.Number,
    label: 'CMB',
    key: 'cmb',
    col: 'cmb'
  },
  claimedValue: {
    type: T.String,
    label: 'Value (in USD)',
    key: 'claimedValue',
    col: 'claimed_value'
  },
  productName: {
    type: T.String,
    label: 'Product Name',
    key: 'productName',
    col: 'product_name'
  },
  shipmentMethod: {
    type: T.String,
    label: 'Shipment Method',
    key: 'shipmentMethod',
    col: 'shipment_method'
  },
  deliveryAddress: {
    type: T.String,
    label: 'Delivery Address',
    key: 'deliveryAddress',
    col: 'delivery_address'
  },
  notes: {
    type: T.Array,
    itemType: T.Ref,
    ref: Note,
    label: 'Note',
    key: 'notes'
  }
}

export const GoodsExcelHeaders = [
  {
    ...Goods.addressCode,
    header: '仓库代码',
    width: 90,
    example: 'ONT8',
    type: T.String,
    validators: [],
    convertor: T.cleanString,
    sortable: 'custom',
    defaultSort: true
  },
  {
    ...Goods.sku,
    width: 120,
    header: 'PRO NO.',
    example: 'CD123456789',
    type: T.String,
    validators: [T.RequiredValidator],
    convertor: T.cleanString,
    sortable: 'custom'
  },
  {
    ...Goods.shipmentNo,
    width: 120,
    header: 'SHIPMENT ID',
    example: 'FBA16K12TBJ3',
    type: T.String,
    validators: [],
    convertor: T.cleanString,
    sortable: 'custom'
  },
  {
    ...Goods.referenceNo,
    header: 'REFERENCE ID',
    example: '4V13NBMZ',
    width: 120,
    type: T.String,
    validators: [],
    convertor: T.cleanString,
    sortable: 'custom'
  },
  {
    ...Goods.quantity,
    header: 'QTY',
    example: 100,
    type: T.Number,
    validators: [T.PositiveValidator],
    convertor: value => value,
    sortable: 'custom'
  },
  {
    ...Goods.kilograms,
    header: 'KGS',
    example: 100,
    type: T.Number,
    validators: [T.PositiveFloatValidator],
    convertor: value => value,
    sortable: 'custom'
  },
  {
    ...Goods.cmb,
    header: 'CBM',
    example: 10,
    type: T.Number,
    validators: [T.PositiveFloatValidator],
    convertor: value => value,
    sortable: 'custom'
  },
  {
    ...Goods.shipmentMethod,
    header: '派送方式',
    example: 'Fedex',
    width: 100,
    type: T.String,
    validators: [],
    convertor: T.cleanString,
    sortable: 'custom'
  },
  {
    ...Goods.deliveryAddress,
    header: '派送地点',
    example: '10999 Bayways, San Bar, CA, 92122',
    type: T.String,
    validators: [],
    convertor: T.cleanString,
    sortable: 'custom'
  },
  {
    label: 'Note',
    key: 'note',
    header: 'Note',
    example: 'This is a note!',
    type: T.String,
    validators: [],
    convertor: value => {
      value = T.cleanString(value)
      return (value ?? '') + ''
    }
  }
]

export const GoodsTableHeaders = [
  ...GoodsExcelHeaders.slice(0, -1).map(one => {
    return {
      ...one,
      label: one.header
    }
  })
]

export const StockGroupGoodsTableHeaders = [
  {
    ...Goods.addressCode,
    label: '仓库代码',
    width: 90,
    type: T.String
  },
  {
    ...Goods.sku,
    width: 120,
    label: 'PRO NO.',
    type: T.String
  },
  {
    ...Goods.shipmentNo,
    width: 120,
    label: 'SHIP ID',
    type: T.String
  },
  {
    ...Goods.referenceNo,
    label: 'REF ID',
    width: 120,
    type: T.String
  },
  {
    ...Goods.quantity,
    label: 'QTY',
    type: T.Number
  },
  {
    ...Goods.shipmentMethod,
    label: '派送方式',
    width: 160,
    type: T.String
  },
  {
    ...Goods.deliveryAddress,
    label: '派送地点',
    width: 100,
    type: T.String
  }
]

export const GoodsForm = Object.fromEntries(
  [
    {
      ...Goods.sku,
      type: T.TextInput,
      span: 1,
      example: 'cd-123456789',
      default: '',
      value: '',
      validators: [T.RequiredValidator],
      convertor: value => value.trim()
    },
    {
      ...Goods.addressCode,
      type: T.TextInput,
      span: 1,
      example: 'SMF6',
      default: '',
      value: '',
      validators: [T.RequiredValidator],
      convertor: value => value.trim()
    },
    {
      ...Goods.shipmentNo,
      type: T.TextInput,
      span: 1,
      example: 'XXXXXXXXX',
      default: '',
      value: '',
      validators: [],
      convertor: value => value.trim()
    },
    {
      ...Goods.referenceNo,
      type: T.TextInput,
      span: 1,
      example: 'XXXXXXXXX',
      default: '',
      value: '',
      validators: [],
      convertor: value => value.trim()
    },
    {
      ...Goods.quantity,
      type: T.NumberInput,
      span: 1,
      example: 100,
      min: 1,
      default: '',
      value: '',
      validators: [T.PositiveValidator],
      convertor: value => value
    },
    {
      ...Goods.kilograms,
      type: T.NumberInput,
      span: 1,
      example: 100,
      default: '',
      min: 0,
      value: '',
      validators: [T.PositiveValidator],
      convertor: value => value
    },
    {
      ...Goods.cmb,
      type: T.NumberInput,
      span: 1,
      example: 100,
      default: '',
      min: 0,
      value: '',
      validators: [T.PositiveFloatValidator],
      convertor: value => value
    },
    {
      ...Goods.claimedValue,
      type: T.TextInput,
      span: 1,
      example: '100',
      default: '',
      value: '',
      min: 0,
      validators: [],
      convertor: value => value.trim()
    },
    {
      ...Goods.productName,
      type: T.TextInput,
      span: 1,
      example: 'Anker',
      default: '',
      value: '',
      validators: [],
      convertor: value => value.trim()
    },
    {
      ...Goods.shipmentMethod,
      type: T.TextInput,
      span: 1,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: value => value.trim()
    },
    {
      ...Goods.deliveryAddress,
      type: T.TextArea,
      span: 1,
      example: 100,
      default: '',
      value: '',
      validators: [],
      convertor: value => value.trim()
    }
  ].map(one => [one.key, one])
)

export const PackingListGoodsWrapUp = goods => {
  NoteWrapUp(goods)
  return goods
}

export const GoodsAddFbaForm = [
  {
    ...Goods.shipmentNo,
    label: 'Shipment ID',
    span: 1,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator]
  }
]

export const BolInstructionForm = [
  {
    key: 'instruction',
    label: 'Instruction',
    span: 1,
    type: T.TextArea,
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator]
  }
]

export const BolGoodsModifyForm = [
  {
    key: 'sku',
    label: 'Customer Ref#',
    span: 1,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator]
  },
  {
    key: 'referenceNo',
    label: 'Reference ID',
    span: 1,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator]
  },
  {
    key: 'quantity',
    label: 'QTY',
    span: 1,
    type: T.NumberInput,
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator]
  },
  {
    key: 'shipmentNo',
    label: 'Shipment ID',
    span: 1,
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator]
  },
  {
    key: 'kilograms',
    label: 'Weight',
    span: 1,
    type: T.NumberInput,
    example: '',
    default: '',
    value: '',
    validators: [T.RequiredValidator]
  }
]
